module.exports = __webpack_public_path__ + "static/media/frames-9.6824e0e4.jpg";